<template>
  <div class="manual-tools02-contents">
    <el-row>
      <el-col>
        <h2>成果データのダウンロード方法（Mobee2）</h2>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h4>
          【１】<a
            href="https://report.mobee2.jp/"
            target="_blank"
            rel="noopener noreferrer"
            >Mobee2の管理画面</a
          >にログインし、管理画面TOPページから「レポート」をクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no10/01.png`" alt="" />
        <h4>
          【２】「広告管理」→「成果一覧」→「詳細条件を開く」の順にクリックします。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no10/02.png`" alt="" />
        <h4>【３】成果期間を選択→「検索」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no10/03.png`" alt="" />
        <h4>
          【４】成果が表示されたら、「計測ID」にクリックパラメータ（{{tool.clickIdName}}_xxx）が表示されているか確認します。
        </h4>
        <img :src="`${rt}/img/manual/${tool.codeKebab}/no07/no10/04.png`" alt="" />
        <p class="red">
          ※パラメータが表示されていない場合、パラメータ引継ぎ設定を間違えている可能性があります。
        </p>
        <p>
          「<router-link :to="`/manual/${tool.codeKebab}/06/02`">パラメータ引継ぎタグを設置する</router-link
          >」をご確認ください。
        </p>
        <h4>
          【５】CSVをダウンロードします。「…」→「エクスポート」の順にクリックしてください。
        </h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no10/05.png`" alt="" />
        <h4>【６】「CSV」をクリックします。</h4>
        <img :src="`${rt}/img/manual/google-cv/no07/no10/06.png`" alt="" />
        <p>
          これで成果CSVのダウンロードは完了です。「<router-link
            :to="`/manual/${tool.codeKebab}/07/14`"
            >ASPの成果データをアドタスカルにインポートする</router-link
          >」に進んでください。
        </p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ManualGoogleCvContents",
  props: {},
  computed: {
    ...mapGetters(["rt","tool"]),
    tools() {
      return this.$store.getters.tools;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
